import React from 'react';
import { Stack } from '@mui/system';
import { Box, Switch } from '@mui/material';
import { Typography, TextField, Grid } from '@mui/material';
import infoIcon from '../../Images/blue_info.svg';
import deleteIcon from '../../Images/delete_red_icon.svg';
import './instrutor.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
	InstructorID,
	showInstructorDetails,
} from '../../redux/features/instructor';
import { API, FOMRS, APP_ROUTES } from '../../globals/constants';
import { useNavigate } from 'react-router-dom';

const InstructorCardView = ({ res, lgWidth, ondeleteClick }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const infoInst = (e) => {
		e.stopPropagation(e);
		navigate(APP_ROUTES.ADD_INSTRUCTOR, {
			state: {
				type: FOMRS.VIEW,
				id: res.id,
			},
		});
	};

	const deleteInst = (e, id) => {
		e.stopPropagation(e);
		ondeleteClick(id);
	};
	return (
		<>
			{res?.length > 0 ? (
				res?.map((res) => {
					let title = res?.name;
					let titlelength = title?.length;
					let slicedTitle = title?.slice(0, 25);

					let trainingCenter = res?.[`studio.studio_name`];
					let trainingCenterLength = trainingCenter?.length;
					let slicedtrainingCenter = trainingCenter?.slice(0, 12);
					return (
						<Grid
							container
							direction="row"
							xs={12}
							sm={6}
							md={lgWidth}
							lg={lgWidth}
							xlg={lgWidth}
						>
							<Box
								sx={{ width: '95%', m: 1, backgroundColor: '#0C0D16' }}
								borderRadius="5px"
								className="cardViewTc"
								id="instructor_CardView"
								onClick={() => {
									dispatch(InstructorID(res?.id));
									dispatch(showInstructorDetails(true));
								}}
							>
								{/* <Stack
									direction="row"
									// mt="2px"
									// justifyContent={'space-between'}
								>
									<Stack
										className="cd-fs-4"
										// className="fs-3"
										sx={{ mt: '4%', ml: '3%' }}
										padding="2%"
									>
										{res?.name}
									</Stack>
									<Grid
										item
										xs={4}
										className="cardRightFlexInst"
										justifyContent="flex-end"
										alignItems=''
									>
										<Box
											sx={{
												bgcolor: '#31323D',
												m: 1,
												borderRadius: 1,
												width: '86px',
												height: '33px',
											}}
										>
											<Stack
												direction="row"
												spacing={2}
												justifyContent="center"
												paddingTop="5%"
											>
												<Stack
													spacing={1}
													sx={{ width: 20, height: 20, p: '2%' }}
												>
													<img
														src={infoIcon}
														alt=""
														onClick={(e) => {
															infoInst(e);
														}}
													/>
												</Stack>
												<Stack
													spacing={1}
													sx={{ width: 16, height: 16, p: '2%' }}
												>
													<img
														src={deleteIcon}
														alt=""
														onClick={(e) => {
															deleteInst(e, res.id);
														}}
													/>
												</Stack>
											</Stack>
										</Box>
									</Grid>
								</Stack> */}
								<Stack direction="row">
									<Grid item xs={8}>
										<Stack
											//className="fs-3"
											className="cd-fs-4"
											sx={{ mt: '4%', ml: '3%' }}
											padding="2%"
										>
											{titlelength > 25 ? `${slicedTitle}...` : res?.name}{' '}
										</Stack>
									</Grid>
									<Grid
										item
										xs={4}
										className="cardRightFlex"
										display="flex"
										justifyContent="flex-end"
									>
										<Box
											sx={{
												bgcolor: '#31323D',
												m: '8% 10%',
												borderRadius: 1,
												width: '86px',
												height: '33px',
											}}
										>
											<Stack
												direction="row"
												spacing={2}
												justifyContent="center"
												paddingTop="5%"
											>
												<Stack
													spacing={1}
													sx={{
														width: 20,
														height: 20,
														p: '2%',
														cursor: 'pointer',
													}}
												>
													<img
														src={infoIcon}
														alt=""
														onClick={(e) => {
															infoInst(e);

															navigate(APP_ROUTES.ADD_INSTRUCTOR, {
																state: {
																	type: FOMRS.VIEW,
																	id: res.id,
																},
															});
														}}
													/>
												</Stack>
												<Stack
													spacing={1}
													sx={{
														width: 16,
														height: 16,
														p: '2%',
														cursor: 'pointer',
													}}
												>
													<img
														src={deleteIcon}
														alt=""
														onClick={(e) => {
															deleteInst(e, res.id);
														}}
													/>
												</Stack>
											</Stack>
										</Box>
									</Grid>
								</Stack>
								<Stack direction="row" spacing={1} margin="2%">
									<Stack ml={'2%'}>
										<span className="cd-fs">{res?.created_at}</span>
									</Stack>
									<Stack
										sx={{
											borderRight: '1px solid #338fee',
											height: '15px',
											m: '2%',
										}}
									></Stack>
									<Stack direction="row">
										<Stack className="cd-fs">Training Center : </Stack>
										<Stack className="cd-fs-3" ml={'5px'} mt="-2px">
											{trainingCenterLength > 12
												? `${slicedtrainingCenter}...`
												: res?.[`studio.studio_name`]}
											{/* {res?.[`studio.studio_name`]} */}
										</Stack>
									</Stack>
								</Stack>
								<Stack>
									<Grid item xs={12}>
										<Stack direction="row">
											<Grid item xs={6}>
												<Stack
													// justifyContent="center"
													height={'100%'}
													margin="7%"
												>
													<Box
														sx={{
															height: '70%',
															// minHeight: { xs: '55px', md: '65px' },
															width: '100%',
															bgcolor: '#31323D',
															borderRadius: 1,
														}}
													>
														<Stack
															textAlign="center"
															sx={{ pt: '6%', pb: '6%' }}
														>
															<Stack className="cd-fs-1">
																{res?.avg_sesseion_length} hrs
															</Stack>
															<Stack className="cd-fs">
																Average Session Length
															</Stack>
														</Stack>
													</Box>
												</Stack>
											</Grid>
											<Grid item xs={6}>
												<Stack height={'100%'} margin="7%">
													<Box
														sx={{
															// minHeight: { xs: '55px', md: '65px' },
															height: '70%',
															width: '100%',
															bgcolor: '#31323D',
															borderRadius: 1,
														}}
													>
														<Stack
															textAlign="center"
															sx={{ pt: '6%', pb: '6%' }}
														>
															<Stack className="cd-fs-1">
																{res?.total_students}
															</Stack>
															<Stack className="cd-fs">Total Students</Stack>
														</Stack>
													</Box>
												</Stack>
											</Grid>
										</Stack>
									</Grid>
									<Grid item xs={12}>
										<Stack direction="row">
											<Grid item xs={6}>
												<Stack height={'100%'} margin="7%">
													<Box
														sx={{
															// minHeight: { xs: '55px', md: '65px' },
															height: '70%',
															width: '100%',
															bgcolor: '#31323D',
															borderRadius: 1,
														}}
													>
														<Stack
															textAlign="center"
															sx={{ pt: '6%', pb: '6%' }}
														>
															<Stack className="cd-fs-1">
																{res?.average_no_of_disconnect}
															</Stack>
															<Stack className="cd-fs">
																Average no. of Disconnect
															</Stack>
														</Stack>
													</Box>
												</Stack>
											</Grid>
											<Grid item xs={6}>
												<Stack height={'100%'} margin="7%">
													<Box
														sx={{
															// minHeight: { xs: '55px', md: '65px' },
															height: '70%',
															width: '100%',
															bgcolor: '#31323D',
															borderRadius: 1,
														}}
													>
														<Stack
															textAlign="center"
															sx={{ pt: '6%', pb: '6%' }}
														>
															<Stack className="cd-fs-1">
																{res?.total_scheduled_trainning}
															</Stack>
															<Stack className="cd-fs">
																Total Scheduled Training
															</Stack>
														</Stack>
													</Box>
												</Stack>
											</Grid>
										</Stack>
									</Grid>
								</Stack>
								<Box
									onClick={() => {
										navigate(APP_ROUTES.TRAINING_LISTING, {
											state: {
												instructor_id: res.id,
												redirect: 'instructorTP',
											},
										});
									}}
									sx={{
										width: '100%',
										height: '30px',
										backgroundColor: 'var(--blueBG)',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										cursor: 'pointer',
									}}
									borderRadius="0px 0px 5px 5px"
								>
									<Stack className="cd-fs-1 showtext" textAlign="center">
										Show Trainings
									</Stack>
								</Box>
							</Box>
						</Grid>
					);
				})
			) : (
				<Stack className="NO_RECORD_FOUND">No Record Found</Stack>
			)}
		</>
	);
};

export default InstructorCardView;
